import React from 'react';
import { Recommended } from './Recommended';
import { Library } from './Library';

export function Main () {
  return (
    <section>
      <Recommended />
      <Library />
    </section>
  )
}